import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import groupBy from 'utils/groupBy';
var AUDIENCE_ALL = 'all';
var AUDIENCE_TEAMS = 'teams';
var ALLOWED_KEY = 'allowed';
var RESTRICTED_KEY = 'restricted';
var CIRCULAR_KEY = 'wouldCauseCircularReference';
export var getChildPlaylistPermissionStatus = function getChildPlaylistPermissionStatus(_ref) {
  var playlistsToCheck = _ref.playlistsToCheck,
    audience = _ref.audience,
    teamIds = _ref.teamIds,
    currentPlaylistId = _ref.currentPlaylistId;
  // Get current playlist permission info
  var parentPlaylistPermissions = {
    audience: audience,
    teamIds: teamIds,
    id: currentPlaylistId
  };
  var groupedPlaylists = groupBy(playlistsToCheck, function (playlist) {
    if (playlist.wouldCauseCircularReference) {
      return CIRCULAR_KEY;
    }
    if (parentPlaylistPermissions.audience === AUDIENCE_ALL) {
      if (playlist.audience === AUDIENCE_ALL) {
        return ALLOWED_KEY;
      } else {
        return RESTRICTED_KEY;
      }
    }
    if (parentPlaylistPermissions.audience === AUDIENCE_TEAMS) {
      if (playlist.audience === AUDIENCE_ALL) {
        return ALLOWED_KEY;
      }
      // Teams needs to check for child matching teams
      if (playlist.audience === AUDIENCE_TEAMS && parentPlaylistPermissions.teamIds.every(function (id) {
        return playlist.teamIds.includes(id);
      })) {
        return ALLOWED_KEY;
      } else {
        return RESTRICTED_KEY;
      }
    }

    // Allow all playlist links if parent playlist is admin
    return ALLOWED_KEY;
  });
  var allowedPlaylists = groupedPlaylists.allowed,
    restrictedPlaylists = groupedPlaylists.restricted,
    circularReferencePlaylists = groupedPlaylists.wouldCauseCircularReference;

  // Boolean for if any playlists have restricted permissions
  var hasRestrictedPlaylists = false;

  // Boolean for if any playlists have restricted permissions
  var hasCircularPlaylists = false;
  if (restrictedPlaylists && restrictedPlaylists.length >= 1) {
    hasRestrictedPlaylists = true;
  }
  if (circularReferencePlaylists && circularReferencePlaylists.length >= 1) {
    hasCircularPlaylists = true;
  }
  return {
    restrictedPlaylists: restrictedPlaylists,
    allowedPlaylists: allowedPlaylists,
    hasRestrictedPlaylists: hasRestrictedPlaylists,
    hasCircularPlaylists: hasCircularPlaylists,
    circularReferencePlaylists: circularReferencePlaylists
  };
};
export default getChildPlaylistPermissionStatus;